import type { Maybe } from '@/types/globals';
import { Injectable } from '@angular/core';
import { Query } from '@datorama/akita';
import { RxNote } from '@modules/notes/models/rx-note';
import { Observable } from 'rxjs';
import { AlignTechNotesState, AlignTechNotesStore } from './aligntech-notes-store';

@Injectable({ providedIn: 'root' })
export class AlignTechNotesQuery extends Query<AlignTechNotesState> {
	alignTechNotesArray$: Observable<Maybe<RxNote[]>> = this.select(state => state.alignTechNotesArray);

	get alignTechNotes(): Maybe<string> {
		return this.getValue().alignTechNotes;
	}
	get alignTechNotesArray(): Maybe<RxNote[]> {
		return this.getValue().alignTechNotesArray;
	}

	constructor(store: AlignTechNotesStore) {
		super(store);
	}
}
